/*
 * Pagina del Dashboard: Permite navegar dentro de la aplicacion
 * Muestra la barra de navegacion, el acceso al perfil y renderiza el modulo y proceso seleccionado
 */

import {
  Dashboard,
  DashboardMain,
  MenuWrapper,
  MenuItems,
  HeaderBoxLeft,
  HeaderBoxRight,
  HeaderWrapper,
  HeaderSearch,
  HeaderUser,
  HeaderUserItem,
  Divider,
  FloatingToolbox,
  shootToast,
} from "codekit";

import DashboardChildRoute from "./DashboardChildRoute";
import MyProfile from "./MyProfile";

import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  getDataUser,
  getMenuUser,
  signOut,
  setMenuUser,
  setModuleURL,
  getIsReplaceUser,
  getInfoUserReplace,
  getInfoUser,
  getIsOtherUser,
  getPreviewInfoUser,
  setReturnUser,
  getSecuenceHistory,
} from "../libs/redux/slices/authSlice/authSlice";
import {
  getModuleSelected,
  getProcesSelected,
  reset,
  setModuleSelected,
  setProcesSelected,
} from "../libs/redux/slices/MenuSlice/menuSlice";
import { useLogoutMutation } from "../libs/redux/slices/authSlice/authApiSlice";
import { useOrderMenuMutation } from "../libs/redux/slices/MenuSlice/menuApliSlice";
import { resetFiltersGraph } from "../libs/redux/slices/Graficsx/graficsxSlice";

import capitalizeWord from "../utils/capitalize-words";
import generateAvatarLetters from "../utils/avatar-letters-generator";
import { resetConsult } from "../libs/redux/slices/consultSlice/consultSlice";
import { resetCustomFilters } from "../libs/redux/slices/trackingSlice/trackingSlice";
import { Notificx } from "./Notificx";
import Usertmpx from "./Usertmpx";
import { useReturnUserMutation, useDeleteHistoryMutation } from "../libs/redux/slices/AdminxxxSlice/adminxxxApiSlice";

import { allowedActionsRow } from "../components/Modimpxx/Testimpx/utils/actionsx";
import Causapay from "../components/Modimpxx/Testimpx/Causapay/Causapay";
import { useUserAbsentMutation, useGetUserAusentMutation } from "../libs/redux/slices/authSlice/authApiSlice";
import Creadoxx from "../components/Modimpxx/Trackimp/Creadoxx/Creadoxx";
import { getCheckedRows } from "../libs/redux/slices/trackingSlice/trackingSlice";
import Userause from "../components/Userause/Userause";

const DashboardPage = () => {
  const dispatch = useDispatch();

  const userData = useSelector(getDataUser);
  const menuData = useSelector(getMenuUser);

  const { MODURLXX } = useSelector(getModuleSelected);
  const { PRODURLX } = useSelector(getProcesSelected);
  const { USREMAXX, USRNOMXX, USRIDXXX } = userData;

  const [orderMenu] = useOrderMenuMutation();
  const [logout] = useLogoutMutation();

  const [menuDataMap, setMenuDataMap] = useState([]);
  const [showMyProfile, setShowMyProfile] = useState(false);
  const [isAusent, setIsAusent] = useState(false);
  const [openModalAusent, setOpenModalAusent] = useState(false);
  const isReplaceUser = useSelector(getIsReplaceUser);
  const [infoUser, setInfoUser] = useState({ USREMAXX, USRNOMXX, USRIDXXX });
  const infoUserReplace = useSelector(getInfoUserReplace);
  const [isCauPay, setIsCauPay] = useState(false);
  const [isNuevoDO, setIsNuevoDO] = useState(false);
  const userInfo = useSelector(getInfoUser);
  const isOtherUser = useSelector(getIsOtherUser);
  const previewUserData = useSelector(getPreviewInfoUser);
  const [returnUserMutation] = useReturnUserMutation();
  const [deleteHistory] = useDeleteHistoryMutation();
  const [userAbsent] = useUserAbsentMutation();
  const [getUserAusent] = useGetUserAusentMutation();
  const SECINGID = useSelector(getSecuenceHistory);
  const selectedRows = useSelector(getCheckedRows);

  // Verificamos el permiso del boton pago causaciones
  const bPermCau = userData?.USERPERM?.some((userPerm) => {
    if (userPerm.MODIDXXX === 117) {
      return userPerm?.CIMS0004?.some((cims0004) => {
        if (cims0004.PROIDXXX === 101) {
          return cims0004?.CIMS0005?.some((cims0005) => cims0005.MENIDXXX === 103);
        }
        return false;
      });
    }
    return false;
  });

  // Verificamos el permiso del boton nuevo DO
  const bPermNuevoDO = userData?.USERPERM?.some((userPerm) => {
    if (userPerm.MODIDXXX === 117) {
      return userPerm?.CIMS0004?.some((cims0004) => {
        if (cims0004.PROIDXXX === 100) {
          return cims0004?.CIMS0005?.some((cims0005) => cims0005.MENIDXXX === 100);
        }
        return false;
      });
    }
    return false;
  });

  const toggleAusent = async () => {
    try {
      const response = await getUserAusent(USRIDXXX).unwrap();
      if (!response.data.ausente) {
        console.log("El usuario ya está marcado como ausente.");
        setOpenModalAusent(true);
      } else {
        await userAbsent({ 'USRIDXXX': USRIDXXX }).unwrap();
      }
    } catch (error) {
      console.error("Error al cambiar el estado de ausencia:", error);
    }
  };

  /**
   * Hook que establece los elementos del menu de navegacion y actualiza su estado activo cuando se seleccionan
   */
  useEffect(() => {
    /**
     * Funcion para guardar el modulo y proceso elegido del menu de navgacion
     */
    const onSelectOption = (moduleItem, processItem) => {
      dispatch(setModuleSelected(moduleItem));
      dispatch(setProcesSelected(processItem));
      setShowMyProfile(false);
    };

    /**
     * Funcion que genera los items del menu de navegacion
     */
    const menuDataMapper = () => {
      return menuData.map((menu) => {
        let isActive = false;

        if (MODURLXX) {
          isActive = menu.MODURLXX === MODURLXX ? true : false;
        }

        const menuDataItem = {
          id: menu.MODIDXXX,
          description: menu.MODDESXX,
          url: menu.MODURLXX,
          icon: `${menu.MODICOXX}`,
          isActive: isActive,
          items: menu.CIMS0004.map((subItem) => ({
            id: subItem.PROIDXXX,
            description: subItem.PRODESXX,
            url: subItem.PRODURLX,
            onClick: () => {
              onSelectOption(menu, subItem);
            },
          })),
        };
        return menuDataItem;
      });
    };

    const menuDataMap = menuDataMapper();

    setMenuDataMap(menuDataMap);
  }, [MODURLXX, menuData, dispatch]);

  /**
   * Hook que setea la URL del modulo para la cabecera de la peticion
   */
  useEffect(() => {
    if (MODURLXX) {
      dispatch(setModuleURL(MODURLXX.toLowerCase()));
    }
  }, [MODURLXX, dispatch]);

  /**
   * Funcion para cerrar sesion del usuario
   */
  const onLogout = async () => {
    if (isOtherUser) {
      await deleteHistory(SECINGID);
    }
    await logout();
    dispatch(signOut());
    dispatch(reset());
    dispatch(resetConsult());
    dispatch(resetCustomFilters());
    dispatch(resetFiltersGraph());
  };

  /**
   * Funcion que vacia el modulo y proceso elegido
   */
  const handleClickHome = () => {
    dispatch(setModuleSelected(""));
    dispatch(setProcesSelected(""));
    setShowMyProfile(false);
  };

  /**
   * Funcion para reordenar los elementos del menu
   */
  const reorderMenuData = (context) => {
    const indexes = context.item.indexes;
    const newIndex = indexes.new;
    const previousIndex = indexes.previous;

    const newMenuData = [...menuData];
    const [removed] = newMenuData.splice(previousIndex, 1);
    newMenuData.splice(newIndex, 0, removed);
    return newMenuData;
  };

  /**
   * Funcion que sirve para guardar el nuevo orden del menu
   */
  const setNewMenuOrder = async (newDataMenu) => {
    const data = newDataMenu.map((module) => {
      return module.MODIDXXX;
    });
    await orderMenu({ MODIDXXX: data }).unwrap();
  };

  /**
   * Funcion que maneja el arrastrado de los items del menu
   */
  const handleMenuDragging = (context) => {
    // Set new menuDataMap order
    const items = context._newItems;
    setMenuDataMap(items);

    // Set new menuData order
    const newMenuData = reorderMenuData(context);
    dispatch(setMenuUser(newMenuData));
    setNewMenuOrder(newMenuData);
  };

  const trackingActions = allowedActionsRow(setIsCauPay);
  const returnUser = async () => {
    let userData = { ...previewUserData };
    let { token: TOKENXXX } = userData.data[0];

    await returnUserMutation({ SECINGID: SECINGID, body: { TOKENXXX: TOKENXXX } })
      .unwrap()
      .then(() => {
        dispatch(setReturnUser({ userData }));
        handleClickHome();
      })
      .catch();
  };

  //Hook que controla el cambio de informacion para el usuario reemplazo
  useEffect(() => {
    if (Object.entries(infoUserReplace).length > 0) {
      setInfoUser({ ...infoUserReplace });
    }
  }, [infoUserReplace]);

  useEffect(() => {
    if (Object.entries(userInfo).length > 0 && !isReplaceUser) {
      setInfoUser({ ...userInfo });
    }
  }, [userInfo, isReplaceUser]);

  //Funcion para validar la creacion de un nuevo DO
  const handleOpenNuevoDO = () => {

    const isDoctraxx = MODURLXX === "Doctraxx";
    const rowsCount = selectedRows.length;

    if (rowsCount === 0) {
      if ((isDoctraxx && PRODURLX === "Saldoctr") || (MODURLXX === "Faccomxx" && PRODURLX === "Salfactx")) {
        shootToast({
          variant: 'warning',
          text: `Debe seleccionar un ${isDoctraxx ? 'Documento de Transporte' : 'Saldo de Documentos'} para crear uno nuevo.`,
          duration: 5000,
        });
        return;
      }

      setIsNuevoDO(true);
      return;
    }

    if (isDoctraxx) {
      if (rowsCount > 1) {
        const firstDtrcnico = selectedRows[0].DTRCNICO;
        const allSameDtrcnico = selectedRows.every(row => row.DTRCNICO === firstDtrcnico);

        if (!allSameDtrcnico) {
          shootToast({
            variant: 'warning',
            text: 'Los Documentos de transporte deben contar con el mismo Cliente, por favor valide.',
            duration: 5000,
          });
          return;
        }

        const areAllZonaFranca = selectedRows.every(row =>
          row.DEPDESXX && row.DEPDESXX.toLowerCase().includes("zona franca")
        );

        if (!areAllZonaFranca) {
          shootToast({
            variant: 'warning',
            text: 'Solo puede seleccionar un Documento de Transporte si el depósito no es Zona Franca.',
            duration: 5000,
          });
          return;
        }
        if (areAllZonaFranca) {
          const firstDepId = selectedRows[0].DEPIDXXX;
          const allSameDepId = selectedRows.every(row => row.DEPIDXXX === firstDepId);

          if (!allSameDepId) {
            shootToast({
              variant: 'warning',
              text: 'Los Documentos de transporte no cuentan con el mismo Depósito por favor valide.',
              duration: 5000,
            });
            return;
          }
        }
      }
      const firstClientId = selectedRows[0].CLIIDXXX;
      const allSameClient = selectedRows.every(row => row.CLIIDXXX === firstClientId);

      if (allSameClient) {
        setIsNuevoDO(true);
      } else {
        shootToast({
          variant: 'warning',
          text: 'Debe seleccionar Saldos de Documentos de un mismo cliente.',
          duration: 5000,
        });
      }
      return;
    }

    if (rowsCount > 0) {
      const firstClientId = selectedRows[0].CLIIDXXX;
      const allSameClient = selectedRows.every(row => row.CLIIDXXX === firstClientId);

      if (allSameClient) {
        setIsNuevoDO(true);
      } else {
        shootToast({
          variant: 'warning',
          text: 'Debe seleccionar Saldos de Documentos de un mismo cliente.',
          duration: 5000,
        });
      }
    }
  };

  return (
    <Dashboard>
      <HeaderWrapper>
        <HeaderBoxLeft>
          <HeaderSearch />
        </HeaderBoxLeft>
        <HeaderBoxRight>
          <Notificx isAusent={isAusent} />
          <FloatingToolbox
            buttons={[
              // Si bPermNuevoDO es true, mostramos el botón
              bPermNuevoDO && {
                icon: "plus",
                tooltip: "Crear Nuevo DO",
                variant: "primary",
                onClick: () => {
                  handleOpenNuevoDO()
                },
              },
              // Si bPermCau es true, mostramos el botón
              bPermCau && {
                icon: "coin",
                tooltip: "Solicitar Pago Causaciones",
                variant: "secondary",
                onClick: () => {
                  setIsCauPay(true);
                },
              },
            ].filter(Boolean)} // Usamos .filter(Boolean) para eliminar valores null
          />
          {isCauPay && <Causapay setIsCauPay={setIsCauPay} />}
          {isNuevoDO && <Creadoxx handleClose={() => setIsNuevoDO(false)} row={selectedRows} setShowCreateDo={setIsNuevoDO} modurlxx={MODURLXX} />}

          <HeaderUser
            image={`${infoUser.USRURLFO && infoUser.USRURLFO !== ""
              ? infoUser?.USRURLFO
              : generateAvatarLetters(`${infoUser.USRNOMXX}`)
              }`}
            name={capitalizeWord(infoUser.USRNOMXX)}
            email={infoUser.USREMAXX.toLowerCase()}
            isReplace={isReplaceUser}
            isAusent={isAusent}
          >
            {!isOtherUser ? (
              <HeaderUserItem icon="user" onClick={() => setShowMyProfile(true)}>
                Mi Perfil
              </HeaderUserItem>
            ) : (
              <HeaderUserItem icon="user-change" onClick={() => returnUser()}>
                Volver a Mi Perfil
              </HeaderUserItem>
            )}
            <Usertmpx handleClickHome={handleClickHome} />
            <HeaderUserItem icon="user-inactive" onClick={toggleAusent}>
              Activar / Inactivar Ausente
            </HeaderUserItem>
            <Divider />
            <HeaderUserItem icon="logout" onClick={onLogout}>
              Cerrar sesión
            </HeaderUserItem>
          </HeaderUser>
        </HeaderBoxRight>
      </HeaderWrapper>
      <MenuWrapper>
        <HeaderUser
          image={`${infoUser.USRURLFO && infoUser.USRURLFO !== ""
            ? infoUser?.USRURLFO
            : generateAvatarLetters(`${infoUser.USRNOMXX}`)
            }`}
          name={capitalizeWord(infoUser.USRNOMXX)}
          email={infoUser.USREMAXX.toLowerCase()}
          isInsideMenu
          isReplace={isReplaceUser}
        >
          <HeaderUserItem icon="user" onClick={() => setShowMyProfile(true)}>
            Mi Perfil
          </HeaderUserItem>
          <Usertmpx handleClickHome={handleClickHome} />
          <HeaderUserItem icon="user-inactive" onClick={toggleAusent}>
            Activar / Inactivar Ausente
          </HeaderUserItem>
          <HeaderUserItem icon="logout" onClick={onLogout}>
            Cerrar sesión
          </HeaderUserItem>
        </HeaderUser>
        <MenuItems
          labelHome="Inicio"
          onClickHome={handleClickHome}
          onMenuDragged={handleMenuDragging}
          items={menuDataMap}
        />
      </MenuWrapper>
      <DashboardMain>
        {showMyProfile ? <MyProfile handleClickHome={handleClickHome} /> : <DashboardChildRoute />}
        {openModalAusent && <Userause infoUser={infoUser} setOpenModalAusent={setOpenModalAusent} />}
      </DashboardMain>
    </Dashboard>
  );
};

export default DashboardPage;
